import { useMemo } from 'react';
import {
  IS_T1_PAGE,
  IS_VLP_PAGE,
  IS_VDP_PAGE,
  IS_OFFERS_PAGE,
  IS_BUILD_PAGE,
  IS_MODELS_PAGE,
  IS_FYM_PAGE,
} from '../constants/environment';

const useSourceOfLead = (topicOfInterest?: string, presetForm?: string | null) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const specificSource = useMemo(() => {
    if (presetForm === 'testDrive') return 'testDrive';
    if (presetForm === 'tradeIn') return 'tradein';
    if (presetForm === 'generic' || presetForm === 'general') return 'generic';
    if (presetForm === 'military') return 'military';
    if (IS_VLP_PAGE) return 'vlp';
    if (IS_VDP_PAGE) return 'vdp';
    if (IS_OFFERS_PAGE) return 'offers';
    if (IS_BUILD_PAGE) return 'config';
    if (IS_MODELS_PAGE) return 'mlp';
    if (IS_FYM_PAGE) return 'fym';
    return 'generic';
  }, [presetForm]);

  const requestSource = useMemo(() => {
    if (IS_T1_PAGE) return 'tier_1';
    return 'tier_3';
  }, []);

  return { url, specificSource, requestSource };
};
export default useSourceOfLead;
